import * as cacheService from '../services/cacheService';
import tree from '../state';

export const clearCacheAction = ({ params, location }, replace, callback) => {

	cacheService.cleanCache().then(res => {
    // cacheService.clearCache(location.query.token).then(res => {
        tree.set('result', res);
        callback();
    }).catch(err => {
		if (err.status === 404) {
			
			tree.set('loading', false);
			callback(); // eslint-disable-line callback-return
		}
		callback(err);
	});;
}; 


// WEBPACK FOOTER //
// ./src/actions/cacheActions.js